/* eslint-disable */
import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  DUMMY_BASE_URL,
  createRequestFunction,
} from '../common';
import {
  License,
  LicenseQuota,
  LicenseRedeemRequest,
  LicenseRedeemResponse,
  LicenseListResponse,
  LicenseQuotaResponse,
} from '../types/license';

/**
 * LicenseServiceApi - axios parameter creator
 * @export
 */
export const LicenseServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Redeem a license using a master key token
     * @summary Redeem license
     * @param {LicenseRedeemRequest} licenseRedeemRequest License redeem request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceRedeem: async (
      licenseRedeemRequest: LicenseRedeemRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'licenseRedeemRequest' is not null or undefined
      assertParamExists('licenseServiceRedeem', 'licenseRedeemRequest', licenseRedeemRequest);
      const localVarPath = `/license/redeem`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        licenseRedeemRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * Get all active licenses for the organization
     * @summary Get active licenses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceGetActive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/license/active`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * Get all licenses for the organization
     * @summary Get all licenses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/license/all`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },

    /**
     * Get license quota information for the organization
     * @summary Get license quota
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceGetQuota: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/license/quota`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LicenseServiceApi - functional programming interface
 * @export
 */
export const LicenseServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LicenseServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * Redeem a license using a master key token
     * @summary Redeem license
     * @param {LicenseRedeemRequest} licenseRedeemRequest License redeem request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async licenseServiceRedeem(
      licenseRedeemRequest: LicenseRedeemRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseRedeemResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.licenseServiceRedeem(
        licenseRedeemRequest,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LicenseServiceApi.licenseServiceRedeem']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * Get all active licenses for the organization
     * @summary Get active licenses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async licenseServiceGetActive(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseListResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.licenseServiceGetActive(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LicenseServiceApi.licenseServiceGetActive']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * Get all licenses for the organization
     * @summary Get all licenses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async licenseServiceGetAll(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseListResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.licenseServiceGetAll(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LicenseServiceApi.licenseServiceGetAll']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },

    /**
     * Get license quota information for the organization
     * @summary Get license quota
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async licenseServiceGetQuota(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LicenseQuotaResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.licenseServiceGetQuota(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['LicenseServiceApi.licenseServiceGetQuota']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * LicenseServiceApi - factory interface
 * @export
 */
export const LicenseServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = LicenseServiceApiFp(configuration);
  return {
    /**
     * Redeem a license using a master key token
     * @summary Redeem license
     * @param {LicenseRedeemRequest} licenseRedeemRequest License redeem request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceRedeem(
      licenseRedeemRequest: LicenseRedeemRequest,
      options?: any
    ): AxiosPromise<LicenseRedeemResponse> {
      return localVarFp
        .licenseServiceRedeem(licenseRedeemRequest, options)
        .then(request => request(axios, basePath));
    },

    /**
     * Get all active licenses for the organization
     * @summary Get active licenses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceGetActive(options?: any): AxiosPromise<LicenseListResponse> {
      return localVarFp.licenseServiceGetActive(options).then(request => request(axios, basePath));
    },

    /**
     * Get all licenses for the organization
     * @summary Get all licenses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceGetAll(options?: any): AxiosPromise<LicenseListResponse> {
      return localVarFp.licenseServiceGetAll(options).then(request => request(axios, basePath));
    },

    /**
     * Get license quota information for the organization
     * @summary Get license quota
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    licenseServiceGetQuota(options?: any): AxiosPromise<LicenseQuotaResponse> {
      return localVarFp.licenseServiceGetQuota(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * LicenseServiceApi - object-oriented interface
 * @export
 * @class LicenseServiceApi
 * @extends {BaseAPI}
 */
export class LicenseServiceApi extends BaseAPI {
  /**
   * Redeem a license using a master key token
   * @summary Redeem license
   * @param {LicenseRedeemRequest} licenseRedeemRequest License redeem request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LicenseServiceApi
   */
  public licenseServiceRedeem(
    licenseRedeemRequest: LicenseRedeemRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LicenseServiceApiFp(this.configuration)
      .licenseServiceRedeem(licenseRedeemRequest, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get all active licenses for the organization
   * @summary Get active licenses
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LicenseServiceApi
   */
  public licenseServiceGetActive(options?: RawAxiosRequestConfig) {
    return LicenseServiceApiFp(this.configuration)
      .licenseServiceGetActive(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get all licenses for the organization
   * @summary Get all licenses
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LicenseServiceApi
   */
  public licenseServiceGetAll(options?: RawAxiosRequestConfig) {
    return LicenseServiceApiFp(this.configuration)
      .licenseServiceGetAll(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * Get license quota information for the organization
   * @summary Get license quota
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LicenseServiceApi
   */
  public licenseServiceGetQuota(options?: RawAxiosRequestConfig) {
    return LicenseServiceApiFp(this.configuration)
      .licenseServiceGetQuota(options)
      .then(request => request(this.axios, this.basePath));
  }
}
